import { configureStore } from '@reduxjs/toolkit'
import counterReducer from './slices/counter/conterSlice'
import {useDispatch} from "react-redux";
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import userReducer from './slices/user/userSlice';



const persistConfig = {
    key: 'root',
    storage,
}
// const persistedReducer = persistReducer(persistConfig, counterReducer)
const persistedUserReducer = persistReducer(persistConfig,userReducer)
export const store = configureStore({
    reducer: {
        auth: persistedUserReducer,
        // counter: persistedReducer,
    },
    middleware: (getDefaultMiddleware:any) => getDefaultMiddleware({serializableCheck: false}),
})




// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, managementUsers: UsersState}
export type AppDispatch = typeof store.dispatch

export const persistor = persistStore(store)
